import mixpanel from 'mixpanel-browser';

export function callRequestStart(data: IUserId) {
  mixpanel.track('call:ad-hoc:request:start', data);
}

export function callRequestCallComplete(data: IUserId) {
  mixpanel.track('call:ad-hoc:request:complete', data);
}